export type BadgeVariant = "default" | "success" | "warning" | "danger" | "info";

export class AppBadge extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "dot"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const attrVariant = this.getAttribute("variant");
    const variant: BadgeVariant =
      attrVariant === "success" || attrVariant === "warning" ||
      attrVariant === "danger" || attrVariant === "info"
        ? attrVariant : "default";

    const showDot = this.getAttribute("dot") !== "false";
    const text = this.textContent?.trim() || "";

    this.className = `badge badge-${variant}`;
    this.innerHTML = `
      ${showDot ? '<span class="badge-dot" aria-hidden="true"></span>' : ""}
      <span>${text}</span>
    `;
  }
}

if (!customElements.get("app-badge")) {
  customElements.define("app-badge", AppBadge);
}

// ── Mapeamento completo de todos os status do domínio ──────────────────────

const STATUS_MAP: Record<string, { variant: BadgeVariant; label: string }> = {
  // Ativos
  ACTIVE:       { variant: "success", label: "ATIVO" },
  INACTIVE:     { variant: "danger",  label: "INATIVO" },
  BLOCKED:      { variant: "danger",  label: "BLOQUEADO" },

  // Relatórios / Inspeções
  DRAFT:             { variant: "default", label: "EM ELABORAÇÃO" },
  IN_ELABORATION:    { variant: "info",    label: "EM ELABORAÇÃO" },
  IN_PROGRESS:       { variant: "info",    label: "EM ELABORAÇÃO" },
  UNDER_ANALYSIS:    { variant: "info",    label: "SOB ANÁLISE" },
  WAITING_PLH:       { variant: "info",    label: "AGUARDANDO PLH" },
  IN_CORRECTION:     { variant: "warning", label: "EM CORREÇÃO" },
  PENDING:           { variant: "warning", label: "PENDENTE" },
  PENDING_SIGNATURE: { variant: "warning", label: "AGUARDANDO ASSINATURA" },
  FINALIZED:         { variant: "success", label: "FINALIZADO" },
  COMPLETED:         { variant: "success", label: "CONCLUÍDO" },
  REPORT_ISSUED:     { variant: "success", label: "LAUDO EMITIDO" },
  APPROVED:          { variant: "success", label: "APROVADO" },
  REJECTED:          { variant: "danger",  label: "REPROVADO" },
  CANCELLED:         { variant: "default", label: "CANCELADO" },

  // Documentos
  SIGNED:     { variant: "success", label: "ASSINADO" },
  ISSUED:     { variant: "success", label: "EMITIDO" },
  VALID:      { variant: "success", label: "VÁLIDO" },
  EXPIRED:    { variant: "danger",  label: "EXPIRADO" },

  // Recomendações
  OPEN:     { variant: "warning", label: "ABERTA" },
  RESOLVED: { variant: "success", label: "RESOLVIDA" },

  // END
  NOT_APPLICABLE: { variant: "default", label: "N/A" },

  // Genérico
  SUCCESS: { variant: "success", label: "CONCLUÍDO" },
  WARNING: { variant: "warning", label: "ATENÇÃO" },
  DANGER:  { variant: "danger",  label: "CRÍTICO" },
  INFO:    { variant: "info",    label: "INFORMAÇÃO" },
  ERROR:   { variant: "danger",  label: "ERRO" },
};

export class AppStatusBadge extends HTMLElement {
  static get observedAttributes() { return ["status"]; }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const raw = (this.getAttribute("status") || "DRAFT").toUpperCase();
    const mapped = STATUS_MAP[raw];
    const variant: BadgeVariant = mapped?.variant ?? "default";
    const label: string = mapped?.label ?? raw;

    this.className = `badge badge-${variant}`;
    this.innerHTML = `
      <span class="badge-dot" aria-hidden="true"></span>
      <span>${label}</span>
    `;
  }
}

if (!customElements.get("app-status-badge")) {
  customElements.define("app-status-badge", AppStatusBadge);
}
